import React from "react";
import "./App.css";
import Home from "./Home/Home";
import { Routes, Route, Navigate } from "react-router-dom";
import PageNotFound from "./PageNotFound/PageNotFound";
import CreatedPage from "./CreatedPage/CreatedPage";

const App: React.FC = () => {
    const bgImage = {
        backgroundImage: `url("/background-image.jpg")`,
        height: "100vh",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
    };
    return (
        <div className='App' style={bgImage}>
            <div className='app-items'>
                <Routes>
                    <Route path='/home' element={<Home />} />
                    <Route path='/created' element={<CreatedPage />} />
                    <Route path='/' element={<Navigate to='/home' replace />} />
                    <Route path='*' element={<PageNotFound />} />
                </Routes>
            </div>
        </div>
    );
};

export default App;
